import { useContext } from "react";
import { AuthContext, IAuthContextType } from "../context";

const useAuth = () => useContext(AuthContext) as IAuthContextType;

export { useAuth };
